import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { grey, info, success, error, warning } from '../neutral/colors.js';
export { error, grey, info, success, warning } from '../neutral/colors.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var primary = {
  primary: '#002B44',
  primary900: '#1a4057',
  primary800: '#335569',
  primary700: '#4d6b7c',
  primary600: '#66808f',
  primary500: '#8095a2',
  primary400: '#99aab4',
  primary300: '#b3bfc7',
  primary200: '#ccd5da',
  primary100: '#e6eaec',
  primary50: '#F2F4F6'
};
var mainColors = {
  darkBlue: '#004E76',
  blue: '#007CBC',
  lightBlue: '#98D5E9',
  white: '#FFFFFF'
};
var supportColors = {
  warmGrey: '#B0A59A',
  warmLightGrey: '#D7D2CB',
  warmLightGrey30: '#e3e0db',
  coldGrey: '#768692',
  coldLightGrey: '#A7BAC9',
  coldLightGrey30: '#c1cfd9'
};
var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, grey), primary), mainColors), supportColors), info), success), error), warning);

export { colors, mainColors, primary, supportColors };
//# sourceMappingURL=colors.js.map
